import CUIImage from 'connect-dot-com-ui-components/Components/CUIImage/CUIImage';
import CUIText from 'connect-dot-com-ui-components/Components/CUIText/CUIText';
import FormattedMessage from 'I18n/components/FormattedMessage';
import SignupButton from '../AuthButtons/SignupButton';
import { CUIFlex } from 'connect-dot-com-ui-components/Components/CUIFlex/CUIFlex';

// @ts-expect-error ts-migrate(7016) NOFIX
import ctaStars from 'bender-url!../../../images/homepageCardImages/cta-stars.svg';
// @ts-expect-error ts-migrate(7016) NOFIX
import ctaCircleStar from 'bender-url!../../../images/homepageCardImages/cta-circle-star.svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function HomepageCta() {
  return /*#__PURE__*/_jsxs(CUIFlex, {
    alignItems: "center",
    bgGradient: "var(--chakra-gradients-magenta-orange)",
    direction: {
      base: 'column',
      md: 'row'
    },
    gap: {
      base: 6,
      md: 20
    },
    justifyContent: "center",
    overflow: "hidden",
    px: {
      base: 6,
      md: 0
    },
    py: 6,
    w: "full",
    children: [/*#__PURE__*/_jsx(CUIImage, {
      alt: "",
      display: {
        base: 'none',
        md: 'block'
      },
      mt: 5,
      src: ctaStars
    }), /*#__PURE__*/_jsx(CUIText, {
      color: "GREYSCALE.MOON",
      fontSize: {
        base: 'xl',
        md: '2xl'
      },
      fontWeight: "bold",
      lineHeight: "shorter",
      maxW: "lg",
      textAlign: {
        base: 'center',
        md: 'left'
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.homepage.cards.ready.title"
      })
    }), /*#__PURE__*/_jsx(SignupButton, {
      flexShrink: 0,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.homepage.cards.ready.cta"
      })
    }), /*#__PURE__*/_jsx(CUIImage, {
      alt: "",
      display: {
        base: 'none',
        md: 'block'
      },
      mb: 5,
      mt: -14,
      src: ctaCircleStar
    })]
  });
}